import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import store from "@/store/index";
import router from "../router";
//import firebase from "firebase";

Vue.use(Vuex);  
axios.defaults.baseURL = "https://api.decsa.co/API";
/*        
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  alert("int-req-ok");
  return config;
}, function (error) {
  // Do something with request error
  alert("int-req-bad");
  return Promise.reject(error);
});
*/

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  //alert("int-rep-ok");
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const errMsg = error.response.data.fault.detail;
    switch (error.response.status){
      case 401:
        switch (errMsg){
          case "Wrong email and/or password":
            break;
          //  return Promise.reject(error);
          //case "Token is not valid":
          //case "Signature is invalid":
          //case "Token is expired":
          default:
            if (store.state.isLoggedIn) {
              store.dispatch("signOut").then(() => {
                Vue.$toast.warning(errMsg + ", please sign in again.", {
                  position: "top",
                });
                router.push("/user/login");
              });
            }
        }
        return Promise.reject(error);
      case 500:
        //console.log("Server error");
        break;
      default:
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);

    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    //console.log("error.request");
    //console.log(error.request);
    //console.log("No internet connection or DECSA server is temporarily unavailable");
  } else {
    // Something happened in setting up the request that triggered an Error
    //console.log('Error', error.message);
  }
  return Promise.reject(error);
});


export default new Vuex.Store({
  state: {
    appVersion : "1.0.0",
    isStaffMember: false,
    current_profile: {
      id: "",
      name: "",
      permission: "",
      type: 0,
    },
    profile_list: [],
    permission_list: [],
    authLevel: 0,
    auth_level_list: [
      { text: 'Decsa', value: 1 },
      { text: 'Carrier', value: 4 },
      { text: 'Consignee', value: 6 },
      { text: 'PUBLIC', value: 7 }
    ],
    error_message: "",
    carrier_code: "",
    consignee_code: "",
    account_id: 0,
    status: "",
    token: localStorage.getItem("token") || "",
    isLoggedIn: false,
    user: {
      id: 0,
      name: "",
      email: "",
    },
    account: {},
    carrier: {},
    carrier_list: [],
    consignee_list: [],
    collections_list: [],
    units_list: [],
    units_recap: [],
    units_at_terminal: [],
    units_at_terminal_recap: [],
    units_at_consignee: [],
    units_at_consignee_recap: [],
    units_with_outstanding: [],
    units_with_outstanding_recap: [],
    transaction_list: [],
    document_list: [],
  },
  mutations: {
    set_auth_level(state, level) {
      state.authLevel = level;
      state.carrier_code = "";
      state.consignee_code = "";
      axios.defaults.headers.common["X-Carrier"] = "";
      axios.defaults.headers.common["X-Consignee"] = "";
    },
    set_carrier_code(state, code) {
      state.carrier_code = code;
      axios.defaults.headers.common["X-Carrier"] = code;
    },
    set_consignee_code(state, code) {
      state.consignee_code = code;
      axios.defaults.headers.common["X-Consignee"] = code;
    },

    data_request(state) {
      state.status = "loading";
    },
    data_success(state) {
      state.status = "success";
    },
    data_error(state) {
      state.status = "error";
    },
    
    create_proforma_request(state) {
      state.status = "Generating the proforma. Please wait ...";
    },
    create_proforma_success(state) {
      state.status = "success";
    },
    create_proforma_error(state) {
      state.status = "error";
    },
    
    create_authorization_request(state) {
      state.status = "Generating the authorization. Please wait ...";
    },
    create_authorization_success(state) {
      state.status = "success";
    },
    create_authorization_error(state) {
      state.status = "error";
    },

    send_email_request(state) {
      state.status = "loading";
    },
    send_email_success(state) {
      state.status = "success";
    },
    send_email_error(state) {
      state.status = "error";
    },

    units_with_outstanding_recap_request(state) {
      state.status = "loading";
      state.units_with_outstanding_recap = [];
    },
    units_with_outstanding_recap_success(state, data) {
      state.status = "success";
      data.sort(function(a, b) {
        let x = (a.unpaid_demurrage||0) + (a.unpaid_detention||0) + (a.unpaid_chassis||0);
        let y = (b.unpaid_demurrage||0) + (b.unpaid_detention||0) + (b.unpaid_chassis||0);
        return y - x;
      });
      state.units_with_outstanding_recap = data;
    },
    units_with_outstanding_recap_error(state) {
      state.status = "error";
    },

    units_recap_request(state) {
      state.status = "loading";
      state.units_recap = [];
    },
    units_recap_success(state, data) {
      state.status = "success";
      state.units_recap = data;
    },
    units_recap_error(state) {
      state.status = "error";
    },

    carrier_list_request(state) {
      state.status = "loading";
      state.carrier_list = [];
    },
    carrier_list_success(state, data) {
      state.status = "success";
      state.carrier_list = data;
    },
    carrier_list_error(state) {
      state.status = "error";
    },

    consignee_list_request(state) {
      state.status = "loading";
      state.consignee_list = [];
    },
    consignee_list_success(state, data) {
      state.status = "success";
      state.consignee_list = data;
    },
    consignee_list_error(state) {
      state.status = "error";
    },

    document_list_request(state) {
      state.status = "loading";
      state.document_list = [];
    },
    document_list_success(state, data) {
      state.status = "success";
      state.document_list = data;
    },
    document_list_error(state) {
      state.status = "error";
    },

    transaction_list_request(state) {
      state.status = "loading";
      state.transaction_list = [];
    },
    transaction_list_success(state, data) {
      state.status = "success";
      state.transaction_list = data;
    },
    transaction_list_error(state) {
      state.status = "error";
    },

    collections_list_request(state) {
      state.status = "loading";
      //state.units_list = [];
    },
    collections_list_success(state, data) {
      state.status = "success";
      state.collections_list = data;
    },
    collections_list_error(state) {
      state.status = "error";
    },

    units_list_request(state) {
      state.status = "loading";
      //state.units_list = [];
    },
    units_list_success(state, data) {
      state.status = "success";
      state.units_list = data;
    },
    units_list_error(state) {
      state.status = "error";
    },

    units_at_terminal_recap_request(state) {
      state.status = "loading";
      state.units_at_terminal_recap = [];
    },
    units_at_terminal_recap_success(state, data) {
      state.status = "success";
      data.sort(function(a, b) {
        let x = (a.unpaid_demurrage||0);
        let y = (b.unpaid_demurrage||0);
        return y - x;
      });
      state.units_at_terminal_recap = data;
    },
    units_at_terminal_recap_error(state) {
      state.status = "error";
    },

    units_at_consignee_recap_request(state) {
      state.status = "loading";
      state.units_at_consignee_recap = [];
    },
    units_at_consignee_recap_success(state, data) {
      state.status = "success";
      data.sort(function(a, b) {
        let x = (a.unpaid_demurrage||0) + (a.unpaid_detention||0) + (a.unpaid_chassis||0);
        let y = (b.unpaid_demurrage||0) + (b.unpaid_detention||0) + (b.unpaid_chassis||0);
        return y - x;
      });
      state.units_at_consignee_recap = data;
    },
    units_at_consignee_recap_error(state) {
      state.status = "error";
    },

    units_at_terminal_request(state) {
      state.status = "loading";
      state.units_at_terminal = [];
    },
    units_at_terminal_success(state, data) {
      state.status = "success";
      //state.units_at_terminal = data;
      state.units_at_terminal = data.map((x) => {
        var i = x.charges[0].phase == "MER" ? 0 : 0;
        var dt = x.charges[i].free_days_stop_on;
        if (dt!=null) {
          x.last_free_day =
            dt.substring(0, 4) +
            "-" +
            dt.substring(4, 6) +
            "-" +
            dt.substring(6, 8);
        }
        return x;
      });
    },
    units_at_terminal_error(state, err) {
      state.status = "error";
      state.error_message = err;
    },

    units_at_consignee_request(state) {
      state.status = "loading";
      state.units_at_consignee = [];
    },
    units_at_consignee_success(state, data) {
      state.status = "success";
      //state.units_at_consignee = data;
      state.units_at_consignee = data.map((x) => {
        var i = x.charges[0].phase == "MER" ? 0 : 1;
        var dt = x.charges[i].free_days_stop_on;
        if (dt!=null) {
          x.last_free_day =
            dt.substring(0, 4) +
            "-" +
            dt.substring(4, 6) +
            "-" +
            dt.substring(6, 8);
        }
        return x;
      });
    },
    units_at_consignee_error(state) {
      state.status = "error";
    },

    units_with_outstanding_request(state) {
      state.status = "loading";
      state.units_with_outstanding = [];
    },
    units_with_outstanding_success(state, data) {
      state.status = "success";
      state.units_with_outstanding = data;
    },
    units_with_outstanding_error(state) {
      state.status = "error";
    },


    load_account_request(state) {
      state.status = "loading";
      state.account_id = 0;
      state.account = {};
      state.collections_list = [];
      state.units_list = [];
      state.units_at_terminal = [];
      state.units_at_consignee = [];
      state.units_with_outstanding = [];
      state.transaction_list = [];
      state.document_list = [];
      state.units_recap = [];
      state.units_at_terminal_recap = [];
      state.units_at_consignee_recap = [];
      state.units_with_outstanding_recap = [];
    },
    load_account_success(state, account) {
      state.status = "success";
      state.account = account;
    },
    load_account_error(state) {
      state.status = "error";
    },

    load_profile_request(state) {
      state.status = "loading";
    },
    load_profile_success(state, profile) {
      state.status = "success";
      state.current_profile = profile;
      state.authLevel = profile.type;
      axios.defaults.headers.common["X-Profile"] = JSON.stringify(profile);
    },
    load_profile_error(state) {
      state.status = "error";
      axios.defaults.headers.common["X-Profile"] = state.current_profile
    },

    profile_list_request(state) {
      state.status = "loading";
    },
    profile_list_success(state, data) {
      state.status = "success";
      state.profiles = data;
      state.current_profile = data[0]
    },
    profile_list_error(state) {
      state.status = "error";
    },

    auth_request(state) {
      //state.status = "loading";
      state.isLoggedIn = false;
      state.authLevel = 0;
      state.isStaffMember = false;
      state.profile_list = [];
      state.permission_list = [];
    },
    auth_success(state, { token, user, profile_list, permission_list, }) {
      //state.status = "success";
      state.isLoggedIn = true;
      
      state.token = token;
      state.user = user;
      state.profile_list = profile_list;
      state.current_profile = profile_list[0];
      state.permission_list = permission_list;

      state.account_id = profile_list[0].id;
      state.authLevel = profile_list[0].type;
      profile_list.forEach(x => {
        if (x.type == 1) state.isStaffMember = true;
      });
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      state.profile_list = [];
      state.isLoggedIn = false;
      state.authLevel = 0;
      state.units_list = [];
      state.units_at_consignee = [];
      state.units_at_terminal = [];
      state.units_with_outstanding = [];
      state.transaction_list = [];
      state.document_list = [];
      state.units_recap = [];
      state.units_with_outstanding_recap = [];
    },
  },
  actions: {
    load_profile({ commit }, profile) {
      commit("load_profile_request");
      axios.defaults.headers.common["X-Profile"] = JSON.stringify(profile);
      commit("load_profile_success", profile);
    },
    
    load_account({ commit }) {
      commit("load_account_request");
      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/WEB/V1/ACCOUNT",
        })
          .then((resp) => {
            commit("load_account_success", resp.data.account);
            resolve(resp);
          })
          .catch((err) => {
            commit("load_account_error");
            reject(err);
          });
      });
    },

    load_dashboard_data({ dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch("load_account")
          .then((resp) => {
            dispatch("get_units_at_terminal_recap");
            dispatch("get_units_at_consignee_recap");
            dispatch("get_units_with_outstanding_recap");
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    get_profile_list({ commit }, search) {
      return new Promise((resolve, reject) => {
        commit("profile_list_request");
        axios({
          url: "/WEB/V1/PROFILES",
          params: search,
          method: "GET",
        })
          .then((resp) => {
            commit("profile_list_success", resp.data.profiles);
            resolve(resp);
          })
          .catch((err) => {
            commit("profile_list_error");
            reject(err);
          });
      });
    },

    get_carrier_list({ commit }, search) {
      return new Promise((resolve, reject) => {
        commit("carrier_list_request");
        axios({
          url: "/WEB/V1/CARRIERS",
          params: search,
          method: "GET",
        })
          .then((resp) => {
            commit("carrier_list_success", resp.data.carrier);
            resolve(resp);
          })
          .catch((err) => {
            commit("carrier_list_error");
            reject(err);
          });
      });
    },

    get_consignee_list({ commit }, search) {
      return new Promise((resolve, reject) => {
        commit("consignee_list_request");
        axios({
          url: "/WEB/V1/CUSTOMERS",
          params: search,
          method: "GET",
        })
          .then((resp) => {
            commit("consignee_list_success", resp.data.customer);
            resolve(resp);
          })
          .catch((err) => {
            commit("consignee_list_error");
            reject(err);
          });
      });
    },

    get_document_list({ commit }, search) {
      return new Promise((resolve, reject) => {
        commit("document_list_request");
        axios({
          url: "/WEB/V1/DOCUMENTS",
          params: search,
          method: "GET",
        })
          .then((resp) => {
            commit("document_list_success", resp.data.document);
            resolve(resp);
          })
          .catch((err) => {
            commit("document_list_error");
            reject(err);
          });
      });
    },

    get_transaction_list({ commit }, search) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/WEB/V1/TRANSACTIONS",
          params: search,
          method: "GET",
        })
          .then((resp) => {
            commit("transaction_list_success", resp.data.document);
            resolve(resp);
          })
          .catch((err) => {
            commit("transaction_list_error");
            reject(err);
          });
      });
    },

    get_units_with_outstanding_recap({ commit }) {
      commit("units_with_outstanding_recap_request");
      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/WEB/V1/OUTSTANDINGS",
        })
          .then((resp) => {
            commit(
              "units_with_outstanding_recap_success",
              resp.data.outstandings
            );
            resolve(resp);
          })
          .catch((err) => {
            commit("units_with_outstanding_recap_error");
            reject(err);
          });
      });
    },

    get_units_recap({ commit }, payload) {
      commit("units_recap_request");
      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/WEB/V1/CONTAINERS/RECAP",
          params: {
            ...payload,
            t : Date.now(),
          },
        })
          .then((resp) => {
            commit("units_recap_success", resp.data.outstandings);
            resolve(resp);
          })
          .catch((err) => {
            commit("units_recap_error");
            reject(err);
          });
      });
    },

    get_units_at_terminal_recap({ commit }, payload) {
      commit("units_at_terminal_recap_request");
      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/WEB/V1/CONTAINERS/RECAP",
          params: {
            ...payload,
            location: "TERMINAL",
            status: "FULL",
            t : Date.now(),
          },
        })
          .then((resp) => {
            commit("units_at_terminal_recap_success", resp.data.outstandings);
            resolve(resp);
          })
          .catch((err) => {
            commit("units_at_terminal_recap_error");
            reject(err);
          });
      });
    },

    get_units_at_consignee_recap({ commit }, payload) {
      commit("units_at_consignee_recap_request");
      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          url: "/WEB/V1/CONTAINERS/RECAP",
          params: {
            ...payload,
            location: "CONSIGNEE",
            status: "FULL",
            t : Date.now(),
          },
        })
          .then((resp) => {
            commit("units_at_consignee_recap_success", resp.data.outstandings);
            resolve(resp);
          })
          .catch((err) => {
            commit("units_at_consignee_recap_error");
            reject(err);
          });
      });
    },

    loadCarrierInfo({ commit }, code) {
      commit("carrier_request");
      let url = "/WEB/V1/CARRIER/" + code;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "GET",
        })
          .then((resp) => {
            commit("carrier_success", resp.data.carrier);
            resolve(resp);
          })
          .catch((err) => {
            commit("carrier_error");
            reject(err);
          });
      });
    },

    get_units_with_outstanding({ commit }, payload) {
      commit("units_with_outstanding_request");
      axios({
        url: "/WEB/V1/CONTAINERS",
        params: {
          ...payload,
          location: "TERMINAL",
          status: "EMPTY",
          only_units_with_AR: "true",
          t : Date.now(),
        },
        method: "GET",
      })
        .then((resp) => {
          commit("units_with_outstanding_success", resp.data.containers);
        })
        .catch((err) => {
          commit("units_with_outstanding_error", err);
        });
    },

    get_units_at_terminal({ commit }, payload) {
      commit("units_at_terminal_request");
      axios({
        url: "/WEB/V1/CONTAINERS",
        params: {
          ...payload,
          location: "TERMINAL",
          status: "FULL",
          t : Date.now(),
        },
        method: "GET",
      })
        .then((resp) => {
          commit("units_at_terminal_success", resp.data.containers);
        })
        .catch((err) => {
          commit("units_at_terminal_error", err);
        });
    },

    get_units_at_consignee({ commit }, payload) {
      commit("units_at_consignee_request");
      axios({
        url: "/WEB/V1/CONTAINERS",
        params: {
          ...payload,
          location: "CONSIGNEE",
          status: "FULL",
          t : Date.now(),
        },
        method: "GET",
      })
        .then((resp) => {
          commit("units_at_consignee_success", resp.data.containers);
        })
        .catch((err) => {
          commit("units_at_consignee_error", err);
          //alert(err);
          //this.handleError(err);
        });
    },

    create_proforma({ commit }, payload) {
      commit("create_proforma_request");
      return new Promise((resolve, reject) => {
        axios({
          url: "/WEB/V1/PROFORMA",
          params: payload,
          method: "GET",
        })
          .then((resp) => {
            commit("create_proforma_success", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("create_proforma_error", err);
            reject(err)
          });
      });
    },
    
    create_authorization({ commit }, payload) {
      commit("create_authorization_request");
      return new Promise((resolve, reject) => {
        axios({
          url: "/WEB/V1/AUTHORIZATION",
          params: payload,
          method: "GET",
        })
          .then((resp) => {
            commit("create_authorization_success", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("create_authorization_error", err);
            reject(err)
          });
      });
    },

    handleError(err) {
      alert(err);
    },

    get_units({ commit }, search) {
      let url = "";
      switch (search.Type) {
        case 0:
          //url = "/WEB/V1/SHIPMENT/" + search.Reference;
          url = "/WEB/V1/CONTAINERS";
          break;
        case 1:
          url = "/WEB/V1/BILLOFLADING/" + search.Reference + "/CONTAINER";
          break;
        case 2:
          url = "/WEB/V1/CONTAINER/" + search.Reference + "/LAST";
          break;
        case 3:
          url = "/WEB/V1/CONTAINERS";
          break;
        default:
          url = "/WEB/V1/CONTAINERS";
          break;
      }

      return new Promise((resolve, reject) => {
        commit("units_list_request");
        axios({
          url: url,
          params: {
            ...search,
            t : Date.now(),
          },
          method: "GET",
        })
          .then((resp) => {
            commit("units_list_success", resp.data.containers);
            resolve(resp);
          })
          .catch((err) => {
            commit("units_list_error");
            reject(err);
          });
      });
    },

    get_collections({ commit }, search) {
      let url = "";
      switch (search.Type) {
        case 0:
          //url = "/WEB/V1/SHIPMENT/" + search.Reference;
          url = "/WEB/V1/COLLECTIONS";
          break;
        case 1:
          url = "/WEB/V1/BILLOFLADING/" + search.Reference + "/CONTAINER";
          break;
        case 2:
          url = "/WEB/V1/CONTAINER/" + search.Reference + "/LAST";
          break;
        case 3:
          url = "/WEB/V1/COLLECTIONS";
          break;
        default:
          url = "/WEB/V1/COLLECTIONS";
          break;
      }

      return new Promise((resolve, reject) => {
        commit("collections_list_request");
        axios({
          url: url,
          params: {
            ...search,
            t : Date.now(),
          },
          method: "GET",
        })
          .then((resp) => {
            commit("collections_list_success", resp.data.collections);
            resolve(resp);
          })
          .catch((err) => {
            commit("collections_list_error");
            reject(err);
          });
      });
    },
    /*
    registerFB({ commit }, user) {
      commit("auth_request");
      firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then((user) => {
          var token;
          firebase
            .auth()
            .currentUser.getIdToken()
            .then((idToken) => (token = idToken))
            .catch((err) => {
              console.log(err);
              alert("Ooops. getting Token" + err.message);
            });
          localStorage.setItem("token", token);
          axios.defaults.headers.common["X-Authorization"] = token;
          commit("auth_success", { token, user });
          this.$router.push("/");
          //resolve(resp);
        })
        .catch((err) => {
          console.log(err);
          alert("Ooops. Creating" + err.message);
          //commit("auth_error");
          //reject(err);
        });
    },

    signOutFB({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          commit("logout");
          localStorage.removeItem("token");
          delete axios.defaults.headers.common["X-Authorization"];
        })
        .catch((err) => {
          console.log(err);
          alert("Ooops. Creating" + err.message);
        });
    },

    signInFB({ commit }, user) {
      firebase
        .auth()
        .signInWithEmailAndPassword(user.email, user.password)
        .then((user) => {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              localStorage.setItem("token", idToken);
              axios.defaults.headers.common["X-Authorization"] = idToken;
              commit("auth_success", { idToken, user });
            })
            .catch((err) => {
              console.log(err);
              alert("Ooops. getting Token" + err.message);
            });
        })
        .catch((err) => {
          commit("auth_error");
          alert("Ooops Signin : " + err.message);
        });
    },
*/
    autoSignIn({ commit }) {
      return new Promise((resolve, reject) => {
        let token = localStorage.getItem("token");
        if (token == null) return;
        axios.defaults.headers.common["X-Authorization"] = token;
        commit("auth_request");
        axios({
          url: "AUTH/V1/AUTOLOGIN",
          method: "GET",
        })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            const profile_list = resp.data.profiles;
            const permission_list = resp.data.permissions;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["X-Authorization"] = token;
            commit("auth_success", { token, user, profile_list, permission_list });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },

    signIn({ commit }, user) {
      return new Promise((resolve, reject) => {
        //let remember = user.remember;
        //localStorage.setItem("remember", remember);
        commit("auth_request");
        axios({
          url: "AUTH/V1/LOGIN",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            const profile_list = resp.data.profiles;
            const permission_list = resp.data.permissions;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["X-Authorization"] = token;
            commit("auth_success", { token, user, profile_list, permission_list });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },

    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "AUTH/V1/REGISTER",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["X-Authorization"] = token;
            commit("auth_success", token, user);
            //this.$router.push("/portal");
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            reject(err);
          });
      });
    },

    signOut({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.removeItem("token");
        delete axios.defaults.headers.common["X-Authorization"];
        resolve();
      });
    },

    resetPassword(X, email) {
      return new Promise((resolve, reject) => {
        axios({
          url: "AUTH/V1/PASSWORD/" + email,
          method: "GET",
        })
          .then((resp) => {
            //commit("auth_reset_password_success", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            //commit("auth_reset_password_error");
            reject(err);
          });
      });
    },

    sendEmail({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("send_email_request");
        axios({
          url: "/WEB/V1/SENDEMAIL",
          method: "POST",
          data: payload,
        })
          .then((resp) => {
            commit("send_email_success", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("send_email_error", err);
            reject(err);
          });
      });
    },

    checkAppUpdate({ commit }) {
      var appInstalledVersion = localStorage.getItem("appVersion");
      if (appInstalledVersion == null) appInstalledVersion = "0.0.0";
      //commit("appVersion_request");
      axios({
        url: "AUTH/V1/APPVERSION",
        method: "GET",
      })
        .then((resp) => {
          const appVersion = resp.data;
          localStorage.setItem("appVersion", appVersion);
          if(appVersion != appInstalledVersion){
            window.location.reload(true);
            commit("appVersion_success", { appVersion });
            //axios.defaults.headers.common["X-appVersion"] = appVersion;
          }
        })
    },

    get_version() {
      return new Promise((resolve, reject) => {
        //commit("api_version_request");
        axios({
          url: "/WEB/V1/VERSION",
          method: "GET",
        })
          .then((resp) => {
            //commit("api_version_success", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            //commit("api_version_error", err);
            reject(err);
          });
      });
    },
  },

  getters: {
    appVersion: (state) => state.appVersion,
    authStatus: (state) => state.status,
    loggedUser: (state) => state.user,
    current_consignee: (state) => state.consignee_code,
    selected_consignee: (state) => state.consignee_code,
    selected_carrier: (state) => state.carrier_code,
    account_id: (state) => state.account_id,
    account: (state) => state.account,
    units_list: (state) => state.units_list,
    collections_list: (state) => state.collections_list,
    units_at_terminal: (state) => state.units_at_terminal,
    units_at_consignee: (state) => state.units_at_consignee,
    units_with_outstanding: (state) => state.units_with_outstanding,
    transaction_list: (state) => state.transaction_list,
    document_list: (state) => state.document_list,
    units_at_terminal_recap: (state) => state.units_at_terminal_recap,
    units_at_terminal_recap_late_in_3_days: (state) =>
      state.units_at_terminal_recap,
    units_at_consignee_recap: (state) => state.units_at_consignee_recap,
    units_at_consignee_recap_late_in_3_days: (state) =>
      state.units_at_consignee_recap,
    units_with_outstanding_recap: (state) => state.units_with_outstanding_recap,
    units_recap: (state) => state.units_recap,
  },
});